import { useNotificationContext } from "providers";
import { useCallback, useState } from "react";
import { requestWithNotify, RequestWithNotifyParams } from "utils/requestWithNotify";

type UseRequestWithNotifyParams = Partial<RequestWithNotifyParams>;

export const useRequestWithNotify = ({
  successMsg,
  errorMsg,
  showErrorNotification,
  delay,
}: UseRequestWithNotifyParams = {}) => {
  const { openNotification } = useNotificationContext();
  const [loading, setLoading] = useState(false);

  const request = useCallback(async (requestFn: () => Promise<any>) => {
    setLoading(true);
    try {
      await requestWithNotify({
        fetchFn: () => requestFn(),
        openNotification: openNotification,
        successMsg: successMsg,
        errorMsg: errorMsg,
        showErrorNotification: showErrorNotification,
        delay: delay,
      });
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    request,
  };
};
